import {Observable} from 'rxjs';

export interface Client {
    id?: number;
    name: string;
    active?: boolean;
}

export abstract class ClientsData {
    abstract list(search: string, pageNumber: number, pageSize: number, orderBy: string): Observable<any>;
    abstract get(id: number): Observable<Client>;
    abstract update(client: Client): Observable<Client>;
    abstract create(client: Client): Observable<Client>;
    abstract delete(client: Client): Observable<Client>;
}

